import React, { useCallback, useState } from "react";

import { useAppStore } from "@store/appStateStore";
import {
  fetchParticipants,
  fetchAttendances,
  fetchTransactions,
  fetchDirections,
} from "@services/api";

import "./Header.css";

const Header: React.FC = () => {
  const {
    isAuth,
    tab,
    setTab,
    user,
    setParticipants,
    setAttendances,
    setTransactions,
    setDirections,
  } = useAppStore();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = useCallback(async () => {
    setIsRefreshing(true);
    try {
      const [participants, attendances, transactions, directions] =
        await Promise.all([
          fetchParticipants(),
          fetchAttendances(),
          fetchTransactions(),
          fetchDirections(),
        ]);
      setParticipants(participants);
      setAttendances(attendances);
      setTransactions(transactions);
      setDirections(directions);
    } catch (error) {
      console.error("Ошибка при обновлении данных:", error);
    } finally {
      setIsRefreshing(false);
    }
  }, [setParticipants, setAttendances, setTransactions, setDirections]);

  return (
    <header className="header">
      <nav className="navbar">
        <ul>
          {isAuth && (
            <li>
              <button
                className="refresh-button"
                onClick={handleRefresh}
                disabled={isRefreshing}
                aria-label="Обновить данные"
              >
                <span className="refresh-icon">
                  {isRefreshing ? "🔄" : "🐦"}
                </span>
                {isRefreshing ? " Обновление..." : " Обновить"}
              </button>
            </li>
          )}
          <li>
            <span
              className={`tabs button ${tab === "home" ? "active" : ""}`}
              onClick={() => setTab("home")}
            >
              Главная
            </span>
          </li>

          {user?.code === "admin" && (
            <li>
              <span
                className={`tabs button ${tab === "participants" ? "active" : ""}`}
                onClick={() => setTab("participants")}
              >
                Участники
              </span>
            </li>
          )}

          {user?.code === "admin" && (
            <li>
              <span
                className={`tabs button ${tab === "transactions" ? "active" : ""}`}
                onClick={() => setTab("transactions")}
              >
                Транзакции
              </span>
            </li>
          )}

          {user?.code === "admin" && (
            <li>
              <span
                className={`tabs button ${tab === "attendances" ? "active" : ""}`}
                onClick={() => setTab("attendances")}
              >
                Посещения
              </span>
            </li>
          )}

          {user?.code === "admin" && (
            <li>
              <span
                className={`tabs button ${tab === "directions" ? "active" : ""}`}
                onClick={() => setTab("directions")}
              >
                Направления
              </span>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
